<template lang="pug">
	.campaign-geotargeting-audience.flex-col.space
		.flex-row.space.widgets-area.segment.justify
			.flex-row.space-large.padding.flex-1
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Total population')}}
					.font-big.statistic-info {{$Data.formatNumber(totalPopulation)}}
				.flex-col.space(v-if="campaign.PopulationStatistic.SelectedPopulation")
					.font-small.upper.grey {{$tCaption('Target audience size')}}
					.font-big.statistic-info {{$Data.formatNumber(campaign.PopulationStatistic.SelectedPopulation)}}

		.flex-row.space-large.widgets-area.segment.flex-1
			.flex-row.space-large.wrap(v-if="layoutGroups")
				.flex-col.space.flex-basis-200.padding.flex-1(v-for="group in layoutGroups")
					.font-big.upper.grey {{ group.caption }}
					DxCheckBox(v-for="item in group.items", :text="item.caption", :value="innerData[item.fieldName]", @value-changed="e => $set(innerData, item.fieldName, e.value)")
			.flex-col.space-large.padding.flex-2
				.flex-col.space.flex-1.align-center
					.font-small.upper.grey {{$tCaption('Target audience size')}}
					.flex-col.space
						DxPieChart(:data-source="audienceData",
							resolve-label-overlapping="shift",
							type="doughnut",
							:size="{ height: 280, width: 280 }", :rotated="true",
							:series="[pieChartSerieConfig()]",
							:legend="{ visible: false}",
							:inner-radius="0.65",
							:palette="['#dedede', '#f27649']",
							center-template="centerTemplate"
						)
							DxTooltip(:enabled="true", :zIndex="100000", format="thousands", :customizeTooltip="(e) => ({ text: `${e.valueText}\n${e.argument}` })")
							template(v-slot:centerTemplate="center")
								svg
									text(text-anchor="middle"
										x="100"
										y="120"
									)
										tspan(:style="{fontSize: 50, fontName: 'Roboto', fontWeight: 100, letterSpacing: '-4px' }", x="100") {{filteredAudiencePercent}}%
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions')", :fullscreen="true")
</template>

<script>
	import _ from 'lodash';
	import { DxTooltip } from 'devextreme-vue/chart';
	import DxPieChart from 'devextreme-vue/pie-chart';
	import DxButton from 'devextreme-vue/button';
	import { DxCheckBox } from 'devextreme-vue/check-box';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'proposal.AudienceSelection',
		name: 'audience-selection',
		components: {
			DxTooltip,
			DxButton,
			DxPieChart,
			DxCheckBox,
			Loader
		},
		props: ['info', 'geoTargeting'],
		data() {
			return {
				ageTooltip: {
					enabled: true,
					format: (v) => `${v}`,
					showMode: 'always',
					position: 'bottom'
				},
				householdTooltip: {
					enabled: true,
					format: (v) => `$${v}K`,
					showMode: 'always',
					position: 'bottom'
				},
				filteredAudience: null,
				innerData: _.cloneDeep(this.geoTargeting.audience || {}),
				isLoading: false
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			},
			totalPopulation() {
				return this.campaign.PopulationStatistic.TotalPopulation || 0;
			},
			selectedPopulation() {
				return this.campaign.PopulationStatistic.SelectedPopulation;
			},
			audienceData() {
				return [
                    { name: this.$tCaption('Other'), value: !this.selectedPopulation ? 0 : (this.totalPopulation - this.selectedPopulation) || 0 },
                    { name: this.$tCaption('Selected'), value: this.selectedPopulation || this.totalPopulation }
                ];
			},
			filteredAudiencePercent() {
				return Math.floor(this.selectedPopulation == null ? 100 : (100 * (this.selectedPopulation || 0) / this.totalPopulation));
			},
			layoutGroups() {
				return this.info.layoutGroups;
			}
		},
		watch: {
			innerData: {
				handler() {
					this.$set(this.campaign.JsonConfig.geoTargeting, 'audience', _.clone(this.innerData));
					this.calculateFilteredAudience();
				},
				deep: true
			},
			filteredAudience(v) {
				if (this.campaign.PopulationStatistic.SelectedPopulation !== v) {
					this.campaign.PopulationStatistic.SelectedPopulation = v;
					this.campaign.PopulationStatistic.NeedUpdate = true;
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.campaignAudience = this;
			this.calculateFilteredAudience();
			this.prepareGroups();
		},
		methods: {
			prepareGroups() {
				this.layoutGroups.map(f => {
					f.items.map(i => {
						if (!this.innerData.hasOwnProperty(i.fieldName)) {
							this.$set(this.innerData, i.fieldName, false);
						}
					});
				});
			},
			pieChartSerieConfig() {
				return {
					argumentField: 'name',
					valueField: 'value',
					label: {
						visible: false,
						backgroundColor: 'none',
						format: 'fixedPoint',
						connector: {
							visible: true
						},
						customizeText: ({ argumentText }) => `${argumentText}`
					}
				};
			},
			calculateFilteredAudience() {
				let selected = this.info.campaign.PopulationStatistic.TotalPopulation || 0;
				let items = this.info.campaign.PopulationStatistic.Items || [];
				this.info.layoutGroups.map(group => {
					let groupHasFilters = group.items.some(f => this.innerData[f.fieldName] === true);
					if (groupHasFilters) {
						let totalForGroup = _.sumBy(group.items.map(f => items.find(i => i.GroupKey === f.fieldName)?.Amount || 0));
						let selectedForGroup = _.sumBy(group.items.filter(f => this.innerData[f.fieldName] === true).map(f => items.find(i => i.GroupKey === f.fieldName)?.Amount || 0));

						if (__DEBUG__)
							console.debug('Filter by group', { group, totalForGroup, selectedForGroup });
						selected = parseInt(selected * selectedForGroup / totalForGroup);
					}
				});

				if (__DEBUG__)
					console.debug('calculateFilteredAudience', { selected });

				this.filteredAudience = selected;
			}
		}
	};
</script>
<style lang='scss'>
	.campaign-geotargeting-audience {
	}
</style>
